import { render, staticRenderFns } from "./impairment.vue?vue&type=template&id=4235ced3&scoped=true&"
import script from "./impairment.vue?vue&type=script&lang=js&"
export * from "./impairment.vue?vue&type=script&lang=js&"
import style0 from "./impairment.vue?vue&type=style&index=0&id=4235ced3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4235ced3",
  null
  
)

export default component.exports